import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Container, Row, Col } from "reactstrap";
import TotalUsersCard from "../../Components/Cards/TotalUserCard";
import TotalMealCard from "../../Components/Cards/TotalMealCard";
import ActiveDietPlanCard from "../../Components/Cards/ActiveDietPlanCard";
import ActiveSubscriptions from "../../Components/Cards/ActiveSubscriptions";
import TotalRestaurantCard from "../../Components/Cards/TotalRestaurantCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardDataList } from "../../slices/thunks";
import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";
import logo from "../../assets/images/sl.png";

const Dashboard = () => {
  const dispatch = useDispatch();

  const selectDashboardState = (state) => state;

  const dashboardSelector = createSelector(selectDashboardState, (state) => ({
    dashboard: state.Dashboard.dashboardData,
    loading: state.Dashboard.loading,
    user: state.Aprofile.user,

    error: state.Dashboard.error,
  }));

  const { dashboard, loading, error, user } = useSelector(dashboardSelector);
  useEffect(() => {
    // dispatch(fetchDashboardDataList());
  }, []);

  document.title = "Dashboard";

  return (
    // <div className="page-content">
    //   <Container fluid>
    //     {loading && (
    //       <div>
    //         <Loader />
    //       </div>
    //     )}

    //     {!loading && !error && (
    //       <Card>
    //         <CardHeader className="d-flex align-items-center flex-wrap gap-2">
    //           <h4 className="card-title mb-0 me-3"> Dashboard</h4>
    //         </CardHeader>
    //       </Card>
    //     )}
    //   </Container>
    // </div>

    <div className="page-content">
      <Container fluid>
        {loading && (
          <div>
            <Loader />
          </div>
        )}

        {!loading && !error && (
          <div
            style={{
              height: "75vh", // full height area
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={user?.profilePic}
              alt="Dashboard Logo"
              style={{
                width: "220px",
                height: "220px",
                objectFit: "contain",
                opacity: 0.9,
              }}
            />
            <h4 className="mt-3 text-muted">Welcome to {user?.name}</h4>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Dashboard;
